DO.Subscribe('app:ready', () => {
  const arrow = document.querySelector('.element-linkblock .dnarrow-wrapper');
  let inview = null;
  if (arrow) {
    inview = new Waypoint.Inview({
      element: arrow,
      entered() {
        this.element.classList.add('active');
      },
      exited() {
        this.element.classList.remove('active');
      },
    });
  }
  return inview;
});
